import type { FC } from "react";
import { AdvisorCard } from "web_myplann/Advisor/Components/AdvisorCard";
import { mapAdvisorCardProps } from "web_myplann/Advisor/Mappers/mapAdvisorCardProps";
import type {
	AgentAssignedListItemResponseDTO,
	AgentDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MissingAdvisor } from "web_myplann/Profile/Components/MissingAdvisor";
import { LoadErrorWithRetry } from "web_myplann/Shared/Components/LoadErrorWithRetry";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";

type Props = {
	isLoading: boolean;
	isError: boolean;
	isRetrying: boolean;
	onRetry: () => void;
	selected?: AgentAssignedListItemResponseDTO;
	detail?: AgentDetailResponseDTO | null;
};

export const AdvisorPageBody: FC<Props> = ({
	isLoading,
	isError,
	isRetrying,
	onRetry,
	selected,
	detail,
}) => {
	const { t } = useResource();

	if (isLoading) return <MyPlannLoading />;
	if (isError)
		return (
			<LoadErrorWithRetry
				title={t(Resources.Advisor.loadError.title)}
				description={t(Resources.Advisor.loadError.description)}
				retryLabel={t(Resources.Advisor.loadError.retry)}
				isRetrying={isRetrying}
				onRetry={onRetry}
			/>
		);
	if (!selected || !detail) return <MissingAdvisor />;

	return <AdvisorCard key={detail.uid} {...mapAdvisorCardProps(detail)} />;
};
